import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getInstagramIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/instagram", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

export async function toggleInstagramComment(
  client: RedoMerchantClient,
  {
    conversationId,
    commentId,
    messageId,
    hide = true,
  }: {
    conversationId: string;
    commentId: string;
    messageId?: string;
    hide?: boolean;
  },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      "support/instagram/toggle-comment",
      { conversationId, commentId, messageId, hide },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    const action = hide ? "hide" : "unhide";
    console.error(`Failed to ${action} Instagram comment:`, error);
    return { success: false };
  }
}

export async function deleteInstagramComment(
  client: RedoMerchantClient,
  { conversationId, commentId }: { conversationId: string; commentId: string },
): Promise<{ success: boolean }> {
  try {
    const response = await client.client.post(
      "support/instagram/delete-comment",
      { conversationId, commentId },
      { headers: client.authorization() },
    );
    return response.data;
  } catch (error) {
    console.error("Failed to delete Instagram comment:", error);
    return { success: false };
  }
}
